// src/pages/PerformanceAssessments/questions.js

export const SCORE_OPTIONS = [1, 2, 3, 4, 5];

export const ROLE_LABELS = {
    analista: 'Analista',
    consultor: 'Consultor',
    consultor_senior: 'Consultor Sénior',
    gestor_area: 'Gestor de Área',
    diretor: 'Diretor',
    gerente: 'Gerente',
};

// Years available in the UI (local, not fetched from the server)
// Descending order: current year → 2020
export const AVAILABLE_YEARS = (() => {
    const startYear = 2020;
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= startYear; y -= 1) years.push(y);
    return years;
})();


// Todos os "grupos" (dimensões) com as 4 questões
export const DIMENSIONS = {
    innovation: {
        key: 'innovation',
        title: 'Inovação',
        questions: [
            '1. Antevê oportunidades e orienta os recursos da empresa para desenvolver novos projetos.',
            '2. Toma decisões com potencial de lucro para a empresa.',
            '3. Propõe soluções de valor para os clientes.',
            '4. Controla a implementação dos novos projetos ou processos.',
        ],
    },
    quality: {
        key: 'quality',
        title: 'Qualidade',
        questions: [
            '1. Decide em função das normas e princípios da Qualidade definidos pela empresa.',
            '2. Implementa soluções de melhoria nos processos em que intervém.',
            '3. Executa as atividades de acordo com os referências normativos em vigor.',
            '4. Informa das ocorrências ou não conformidades identificadas no decorrer da sua atividade.',
        ],
    },
    commitment: {
        key: 'commitment',
        title: 'Compromisso',
        questions: [
            '1. Realiza as suas tarefas dentro do que lhe foi proposto.',
            '2. Assume prontamente as consequências das suas ações e decisões independentemente dos resultados apresentados.',
            '3. Hierarquiza as atividades e objetivos em função da sua contribuição para os resultados centrais da organização.',
            '4. Mostra-se disponível para concretizar com sucesso os seus objetivos e os da empresa.',
        ],
    },
    client_orientation: {
        key: 'client_orientation',
        title: 'Orientação para o Cliente',
        questions: [
            '1. Revela empatia, respeito e disponibilidade na relação com o cliente.',
            '2. Assume prontamente as consequências das suas ações e decisões independentemente dos resultados apresentados.',
            '3. Hierarquiza as atividades e objetivos em função da sua contribuição para os resultados centrais da organização.',
            '4. Utiliza o feedback dos clientes como um fator de melhoria contínua.',
        ],
    },
    team_management: {
        key: 'team_management',
        title: 'Gestão de Equipas',
        questions: [
            '1. Orienta a equipa para ações coerentes com os valores e a estratégia da empresa.',
            '2. Incute na equipa a eficiência e a eficácia das atividades e tarefas.',
            '3. Encoraja e reconhece o contributo dos elementos da equipa.',
            '4. Motiva a equipa para o sucesso dos resultados.',
        ],
    },
    planning: {
        key: 'planning',
        title: 'Planeamento',
        questions: [
            '1. Planeia a atividade de acordo com os objetivos definidos.',
            '2. Define prioridades tendo em conta os objetivos a alcançar e os recursos existentes.',
            '3. Acompanha, controla e avalia a execução dos projetos e atividades assegurando o seu desenvolvimento e a sua realização de acordo com os prazos e custos definidos.',
            '4. Revê e ajusta o planeamento efetuado, mantendo-o atualizado e adaptando-o a alterações e circunstâncias imprevistas.',
        ],
    },
    autonomy: {
        key: 'autonomy',
        title: 'Autonomia',
        questions: [
            '1. Age medindo o impacto que as suas ações têm nos processos.',
            '2. Desenvolve o seu trabalho de forma independente, sem necessidade de supervisão constante.',
            '3. Toma a iniciativa de apresentar soluções para situações ou problemas, sem esperar que lhe sejam solicitadas.',
            '4. Solicita feedback de forma moderada e variável, em função do grau de complexidade da tarefa.',
        ],
    },
    organization: {
        key: 'organization',
        title: 'Capacidade de Organização',
        questions: [
            '1. Planeia e executa as suas tarefas, em função de uma hierarquia de objetivos bem definida.',
            '2. Desenvolve as suas tarefas de forma lógica, otimizando o consumo de tempo e recursos.',
            '3. Mantém os locais de trabalho, físico e virtual,  organizados.',
            '4. Promove novas formas de organização com vista a maior eficácia no trabalho.',
        ],
    },
    results: {
        key: 'results',
        title: 'Orientação para Resultados',
        questions: [
            '1. Grau de cumprimento dos objetivos estratégicos e operacionais fixados.',
            '2. Mostra motivação para superar os objetivos do seu trabalho.',
            '3. É capaz de desbloquear obstáculos relacionados com o seu trabalho.',
            '4. Introduz correções aos planos com vista a melhorar e em alcançar padrões elevados de excelência.',
        ],
    },
    rigor: {
        key: 'rigor',
        title: 'Rigor',
        questions: [
            '1. É capaz de se concentrar na análise crítica da informação recebida.',
            '2. É exigente com a qualidade do trabalho que desenvolve.',
            '3. Perante um problema ou anomalia analisa exaustivamente os dados e toma as iniciativas necessárias para a correção de eventuais erros.',
            '4. Assegura escrupulosamente o detalhe/pormenor de todos os trabalhos que executa.',
        ],
    },
    teamwork: {
        key: 'teamwork',
        title: 'Trabalho em Equipa',
        questions: [
            '1. Partilha informação e recursos de forma a facilitar o alcance de objetivos comuns.',
            '2. É recetivo e respeita as ideias e opiniões dos outros.',
            '3. Promove um clima de abertura e diálogo, que favoreça a interação e o fortalecimento do espírito de equipa.',
            '4. Oferece ajuda e apoia os outros na concretização dos seus objetivos e dos da equipa.',
        ],
    },
    project_management: {
        key: 'project_management',
        title: 'Gestão de Projetos',
        questions: [
            '1. Identifica linhas inovadoras e de  interesse estratégico ao nível de projetos.',
            '2. Reúne a informação necessária para suporte à elaboração/ construção de projetos.',
            '3. Utiliza os conceitos e metodologias adequadas ao projeto.',
            '4. Descreve de forma coerente e estruturada a informação pertinente para cada projeto.',
        ],
    },
    project_execution: {
        key: 'project_execution',
        title: 'Execução de Projetos',
        questions: [
            '1. Define os recursos e meios necessários à execução de um ou mais projetos.',
            '2. Implementa e/ou acompanha as atividades necessárias ao desenvolvimento dos projetos.',
            '3. Controla os prazos de execução e suas condicionantes.',
            '4. Resolve os problemas e gere o feedback dos clientes.',
        ],
    },
    it: {
        key: 'it',
        title: 'Capacidade de utilização das TIC',
        questions: [
            '1. Define os recursos e meios necessários à execução de um ou mais projetos.',
            '2. Implementa e/ou acompanha as atividades necessárias ao desenvolvimento dos projetos.',
            '3. Controla os prazos de execução e suas condicionantes.',
            '4. Resolve os problemas e gere o feedback dos clientes.',
        ],
    },
    technical_capacity: {
        key: 'technical_capacity',
        title: 'Capacidade Técnica',
        questions: [
            '1. Executa e ajusta as atividades relativas aos projetos.',
            '2. Identifica as melhores práticas e generaliza esse conhecimento para outros projetos.',
            '3. Domina e implementa conhecimento especifico do projeto.',
            '4. Mantém atualizada toda a informação referente a atividades/projetos.',
        ],
    },
    sales: {
        key: 'sales',
        title: 'Técnicas de venda e negociação de projetos',
        questions: [
            '1. Identifica corretamente as características e funcionalidades do projeto/processo em venda.',
            '2. Identifica as necessidades e desejos dos clientes.',
            '3. Adota um discurso coerente baseado em argumentos e técnicas de venda eficazes.',
            '4. Gere a relação comercial com eficácia.',
        ],
    },
    knowledge: {
        key: 'knowledge',
        title: 'Conhecimento, Informação das normas',
        questions: [
            '1. Interpreta e atualiza conhecimento específico, legislação e normas.',
            '2. Aplica-os de forma adequada.',
            '3. Capacidade de elaborar pareceres técnicos.',
            '4. Garantir a confidencialidade e segurança de toda a informação, interna e externa.',
        ],
    },
};

// Dimensões usadas em cada papel
export const ROLE_DIMENSIONS = {
    analista: ['quality', 'autonomy', 'rigor', 'teamwork', 'it'],
    consultor: [
        'quality',
        'commitment',
        'autonomy',
        'rigor',
        'teamwork',
        'project_execution',
        'technical_capacity',
    ],
    consultor_senior: [
        'innovation',
        'quality',
        'client_orientation',
        'organization',
        'results',
        'project_management',
        'technical_capacity',
        'knowledge',
    ],
    gestor_area: [
        'innovation',
        'quality',
        'client_orientation',
        'team_management',
        'planning',
        'results',
        'technical_capacity',
        'sales',
    ],
    diretor: [
        'innovation',
        'quality',
        'commitment',
        'client_orientation',
        'team_management',
        'planning',
        'results',
        'rigor',
        'technical_capacity',
    ],
    gerente: [
        'innovation',
        'quality',
        'commitment',
        'client_orientation',
        'team_management',
        'planning',
        'results',
        'rigor',
    ],
};

export const getGroupsForRole = (role) => {
    const keys = ROLE_DIMENSIONS[role] || [];
    return keys.map((k) => DIMENSIONS[k]).filter(Boolean);
};

// Inicializa o form a partir de um registo de avaliação
export const buildInitialForm = (assessment = {}) => {
    const base = {};
    Object.keys(DIMENSIONS).forEach((dimKey) => {
        for (let i = 1; i <= 4; i += 1) {
            const field = `${dimKey}_${i}`;
            const val = assessment[field];
            base[field] = Number.isFinite(val) ? val : null;
        }
    });

    base.observations = assessment.observations || '';
    return base;
};

export const formatScore = (value) => {
    if (value === null || value === undefined) return '—';
    const num = Number(value);
    if (Number.isNaN(num)) return '—';
    // se for inteiro, não mostrar casas decimais; senão, 2 casas
    return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};
